import { useEffect, useState } from 'react';
import { ChevronDown, Filter } from 'lucide-react';
import useIsMobile from '../hooks/useIsMobile';

/**
 * Collapsible "Филтери" card shared by the list pages.
 *
 * Collapsed by default on phones — the filter inputs otherwise push the table
 * a full screen down, so you land on a list page and see no list. Expanded by
 * default on desktop, where there is room for both.
 */
export default function FiltersPanel({ children }) {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(!isMobile);

  // Re-apply the default when crossing the breakpoint (rotating a phone,
  // resizing a window). A deliberate toggle survives until that happens.
  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 mb-4">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center justify-between text-left"
      >
        <h2 className="text-sm font-semibold text-gray-900 flex items-center space-x-1.5">
          <Filter className="w-4 h-4 text-gray-600" />
          <span>Филтери</span>
        </h2>
        <ChevronDown
          size={16}
          className={`text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>

      {open && <div className="mt-2">{children}</div>}
    </div>
  );
}
